import React, { Component } from 'react';

import { isEmpty, some } from "lodash"

import { TableLayout } from '../Menu/Stock/containers/Layout';

import {  toast } from 'react-toastify';

import FormNewUser from './Users/FormNewUser';
import FormNewRole from './Users/FormNewRole';
import FormChangeUserRole from './Users/FormChangeUserRole';
import FormUpdateRole from './Users/FormUpdateRole';
import { TableHead, TableRow, TableBody, TableCell, Button, Grid, IconButton, Chip, Tooltip } from '@material-ui/core';
import { AddCircleOutline, EditRounded, PersonRounded,Delete, BlockRounded, LockOpenRounded, HistoryRounded } from '@material-ui/icons';
import PageAdmin from './Layouts/PageAdmin';
import SearchBarAction from './Layouts/SearchBarAction';
import { blue } from '@material-ui/core/colors';
import CardButton from '../../commonModules/interface/CardButton';
import Dialog from '../../commonModules/interface/Dialog';

// Libellé du blocage des mutations sur un compte encore exploitable pour les
// actions d'accès. Utilisé uniquement sous la prop suspendAllBase (AC-17, AC-18).
const MUTATIONS_BLOCKED_TITLE = "Compte non exploitable pour les modifications : administrateur du compte incohérent"

const initErrors = {
    role:"",
    email:"",
    userName:"",
    userPassword:"",
    pages:"",
    roleName:"",
    confirmMDP:"",
}
const PAGES = 
    [
        {value: "1000_Dashboard_Page", label: "Dashboard"},
        {value: '2000_Home_Page', label: 'Home' }, 
        {value: '3000_Entrer Paiement_Page', label: 'Entrer Paiement' },
        {value: '4000_Paiement_Page', label: 'Paiement' },
        // {value: "5000_Configuration_Page", label: "Configuration"}, admin Only
        // {value: "5500_Extract_Page", label: "Extract"},
        {value: "6000_Commercial_Page", label: "Commercial"},
        {value: "6500_Devis_Page", label: "Devis"},
        {value: "7000_Magasin_Page", label: "Magasin"},
        {value: "8000_Maintenance_Page", label: "Maintenance"},
        {value: "9000_Recouvrement_Page", label: "Recouvrement"},
        //{value: "10000_Production_Page", label: "Production"},
        //{value: "11000_Consommation_Page", label: "Consommation"},
        //{value: "12000_Financement_Page", label: "Financement"},
        //{value: "13000_Spendings_Page", label: "Dépenses"},
        {value: "14000_Mini-grid_Page", label: "Mini-grid"},
        {value: "15000_Integrations_Page", label: "Intégration"},

        // { value : "1_stats_Config", label: "Config - Home"},
        { value : "2_abo_Config", label: "Config - Abonnements"},
        { value : "19_aboadmin_Config", label: "Config - Abonnements (admin)"},
        { value : "3_agent_Config", label: "Config - Commerciaux"},
        { value : "21_agentadmin_Config", label: "Config - Commerciaux (admin)"},
        { value : "4_schema_Config", label: "Config - Schémas"},
        { value : "5_sim_Config", label: "Config - Sim"},
        { value : "6_sms_Config", label: "Config - SMS"},
        { value : "20_smsadmin_Config", label: "Config - SMS (admin)"},
        { value : "7_alert_Config", label: "Config - Alerte"},
        { value : "8_box_Config", label: "Config - Systèmes et Box"},
        { value : "9_installer_Config", label: "Config -  Techniciens"},
        { value : "10_users_Config", label: "Config - Utilisateurs"},
        { value : "11_extract_Config", label: "Config - Extract"},
        { value : "12_upload_Config", label: "Config - Upload"},
        { value : "13_uploadstore_Config", label: "Config - Upload Magasin"},
        // { value : "14_credit_Config", label: "Config - Crédit"},
        // { value : "15_funding_Config", label: "Config - Financement"},
        // { value : "16_company_Config", label: "Config - Entreprise"},
        { value : "17_matching_Config", label: "Config - Match Produits"},
        // { value : "18_codesuperadmin_Config", label: "Config - Code Superadmin"},
    ]
// correspondance clé (value) -> libellé, pour afficher les memes noms que le dropdown PAGES
const PAGE_LABEL = PAGES.reduce((acc, p) => { acc[p.value] = p.label; return acc; }, {});
const pageLabel = (key) => PAGE_LABEL[key] || (key ? key.split("_")[1] : key) || key;

// libellés des actions d'historique renvoyés par /userRole/userHistory
const ACCESS_ACTION_LABEL = {
    suspend: "Suspension",
    reactivate: "Réactivation",
}
const accessActionLabel = (action) => ACCESS_ACTION_LABEL[action] || action || ""
// Portée de la ligne d'historique (AC-12). Le serveur pose scope:"global" sur les
// lignes écrites par une suspension « tous ses comptes ». Le champ est absent des
// lignes antérieures et de tout le chemin admin de compte : le libellé y reste
// exactement celui d'aujourd'hui, sans colonne supplémentaire (AC-18).
const accessEntryLabel = (entry) => ((entry && entry.scope === 'global')
    ? accessActionLabel(entry.action) + " (tous ses comptes)"
    : accessActionLabel(entry && entry.action))
// date RFC3339 renvoyée par domainModel -> affichage local, sans planter si la valeur est vide ou illisible
const formatAccessDate = (value) => {
    if (!value) { return "" }
    const date = new Date(value)
    if (isNaN(date.getTime())) { return value }
    return date.toLocaleString('fr-FR')
}
class UsersList extends Component {
    state = {
        list:[],
        roleList:[],
        roleNames: {},

        roleU:"",// ROLE UPDATE
        roleUDisplay:{value:"", label:""},
        user: {},

        role:"",
        roleDisplay:{value:"", label:""},
        email:"",
        userName:"",
        userPassword:"",
        pages:[],
        roleName:"",
        confirmMDP:"",
        errors:initErrors,

        
        newUser:false,
        newRole:false,
        changeRole:false,
        updatePageList:false,

        // suspension / réactivation d'un accès au compte courant
        confirmSuspend:null,    // utilisateur en attente de confirmation de suspension
        // Dialogue de CHOIX « ce compte seulement / tous ses comptes ». Ne peut être
        // renseigné que depuis le chemin SuperAdmin, qui seul passe la prop suspendAllBase.
        confirmSuspendChoice:null,
        accessPending:false,    // une action suspend/reactivate est en cours
        historyUser:null,       // utilisateur dont on consulte l'historique
        historyList:[],
        historyLoading:false,
        historyError:"",
    }
    // '/userRole' = page admin de compte (comportement historique) ;
    // '/superadmin/account/<id>' = onglet SuperAdmin, meme jeu de routes sur un autre compte.
    apiBase = () => this.props.apiBase || '/userRole'
    componentDidMount = async  () => {
        const { USERS } = this.props;
        if( !USERS ){
            await this.props.fetchUsers(this.apiBase())
            await this.props.fetchRoles(this.apiBase())
        }
        this.filterList()
        this.getRoleList()
    }
    filterList = (list) => {
        if( !list ){
            if(!isEmpty(this.props.USERS) ){
                list = Object.keys(this.props.USERS)
            } else {
                list = []
            }
        }
        this.setState({
            list
        })
    }
    getRoleList = async ()=>{
        const { ROLES } = this.props;
        if(ROLES){
            let roles = []
            let roleNames = {}
            Object.keys(ROLES).map(ID => {
                let role = ROLES[ID]
                // access: libellés lisibles (alignés avec le dropdown PAGES)
                let access = role.accessPage.map(pageLabel)
                // accessOptions: options {value,label} pour pré-remplir le multi-select
                let accessOptions = role.accessPage.map(key => ({ value: key, label: pageLabel(key) }))
                roles.push({
                    value:role.id, label:role.name, access:access, accessOptions:accessOptions
                })
                roleNames[role.name] = role.id

            })
            this.setState({
                roleList:roles,
                roleNames,
            })
        } else {
            this.setState({
                roleList:[{value:"", label:"", access: []}]
            })
        }
    }

    handleChange = (e) =>{
        let value = e.target.value
        let name = e.target.name
        this.setState({
            [name]: value
        })
    }
    handleSelectPage = (pages) => {
        this.setState({ pages });
        console.log(`Option selected:`, pages);
    }
    handleSelect = (option, field) => {
        let display = field+"Display"
        let next = {
            [display]: option,
            [field]: option.value
        }
        if (field === "role" && option && option.accessOptions) {
            // pré-sélection des pages actuelles du role choisi
            next.pages = option.accessOptions
        }
        this.setState(next)
    }
    validate = () =>{
        let noErrors = true
        let errors = {}
        const user = ['email', 'userName', 'role', 'userPassword']
        const role = ['roleName', 'pages']
        if(this.state.newUser === true){
            user.map( field  => {
                if (this.state[field] === "" || !this.state[field]){
                    errors[field] = 'Veuillez remplir ce champ'
                    noErrors = false
                } else {
                    errors[field]= ''
                }
            })
            if(this.state.userPassword !== this.state.confirmMDP){
                errors.confirmMDP = 'Le mot de passe et sa confirmation doivent etre identique'
                noErrors = false
            } else {
                errors.confirmMDP = ''
            }
        }

        if (this.state.newRole === true){
            role.map((field)=>{
                if (this.state[field] === "" || !this.state[field] || this.state[field].length === 0 ){
                    errors[field] = 'Veuillez remplir ce champ'
                    noErrors = false
                } else {
                    errors[field]= ''
                }
            })
        }
        this.setState({...this.state,errors})
        console.log("VALIDATE",{noErrors, errors});
        
        return noErrors
    }
    handleSubmit = async () =>{
        if(this.validate()){
            let data = {} 
            if (this.state.newUser === true){
                data.email = this.state.email
                data.userName = this.state.userName
                data.userPassword = this.state.userPassword
                data.roleID = this.state.role

                try {
                    let req = await fetch(this.apiBase() + '/addUser',{
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        body: JSON.stringify(data),
                        credentials: 'same-origin',
               
                    })
                    const res = await req.json()
                    console.log("handleSubmit user",{res});
                    
                    if(!res.errorCode){

                        toast.done( "Nouvel utilisateur enregistré")
                        this.clearForms()

                        // update redux this.getUserList()
                    } else {
                        toast.error(res.content)
                    }
                } catch (error) {
                    toast.error( "Erreur", error)
                }
            }
            else if (this.state.newRole === true){
                data.roleName = this.state.roleName
                data.accessPages = []
                this.state.pages.map((page)=>{
                    data.accessPages.push(page.value)
                })

                try {
                    let req = await fetch(this.apiBase() + '/addRole',{
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        body: JSON.stringify(data),
                        credentials: 'same-origin',
               
                    })
                    const res = await req.json()
                    console.log("handleSubmit role",{res});
                    if(!res.errorCode){
                        toast.success("Nouveau role enregistré")
                        this.clearForms()
                        // update redux this.getRoleList()
                    } else {
                       // this.props.notif( "danger", res.content, "Erreur")
                        toast.error(res.content)

                    }
                } catch (error) {
                    //this.props.notif( "danger", error, "Erreur")
                    toast.error(error)

                }
            }
            // submit requset
        } else {
            toast.error("Le formulaire contient des erreurs")
        }
    }
    
    handleUpdateRole = async () => {
        console.log('====================================');
        console.log("update role submit");
        console.log('====================================');
        if(this.state.role && !isEmpty(this.state.pages) ){
            console.log("OK", this.state.role, this.state.pages);
            let data = {} 
            if (this.state.updatePageList === true){
                data.accessPages = []
                this.state.pages.map( page => {
                    data.accessPages.push(page.value)
                })
                data.roleID = this.state.role

                try {
                    let req = await fetch(this.apiBase() + '/updateRole',{
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        body: JSON.stringify(data),
                        credentials: 'same-origin',
               
                    })
                    const res = await req.json()
                    console.log("Update role ",{res});
                    
                    if(!res.errorCode){

                        toast.success("Role modifié")
                        this.clearForms()

                        // update redux this.getUserList()
                    } else {
                        console.log('====================================');
                        console.log("[ERROR] submit Update", res);
                        console.log('====================================');
                        // this.props.notif( "danger", "Un problème est survenu", "Erreur")
                    }
                } catch (error) {
                    console.log('====================================');
                    console.log("[ERROR] catch submit Update", error);
                    console.log('====================================');
                    // this.props.notif( "danger", error, "Erreur")
                }
            }
        } else {
            toast.error("Le formulaire contient des erreurs")
        }
    }
    handleChangeUserRole = async () =>{
        if(this.state.roleU && this.state.user.email){
            let data = {} 
            if (this.state.changeRole === true){
                data.email = this.state.user.email
                data.roleID = this.state.roleU

                try {
                    let req = await fetch(this.apiBase() + '/updateUser',{
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        body: JSON.stringify(data),
                        credentials: 'same-origin',
               
                    })
                    const res = await req.json()
                    console.log("Update role ",{res});
                    
                    if(!res.errorCode){

                        toast.success("Role utilisateur modifié")
                        this.clearForms()

                        // update redux this.getUserList()
                    } else {
                        console.log('====================================');
                        console.log("[ERROR] submit Update", res);
                        console.log('====================================');
                        // this.props.notif( "danger", "Un problème est survenu", "Erreur")
                    }
                } catch (error) {
                    console.log('====================================');
                    console.log("[ERROR] catch submit Update", error);
                    console.log('====================================');
                    // this.props.notif( "danger", error, "Erreur")
                }
            }
        } else {
            toast.error("Le formulaire contient des erreurs")
        }
    }

    // Identité de l'utilisateur connecté, pour ne jamais lui proposer de se suspendre lui-même.
    // Deux sources, dans cet ordre :
    //  - le store auth (même logique que maincontentadminpayg.jsx) : donne l'accessUserID.
    //    Branche INERTE aujourd'hui : `auth` n'est pas passé jusqu'à ce composant (ni
    //    mapStateToProps d'AdminDashboard, ni indexAdmin) ; conservée pour le jour où il le sera ;
    //  - localStorage.userId, posé au login (authAction.jsx) : c'est la clé de document,
    //    comparable au champ userID renvoyé par /userRole/userList.
    // Les deux peuvent être vides : dans ce cas le bouton reste affiché et c'est le backend
    // qui refuse en 400 cannot_suspend_self.
    getCurrentUserIdentity = () => {
        const authUser = this.props.auth?.user || {}
        const accountID = authUser.accountid || localStorage.accountId || ''
        let accessUserID = ''
        if (accountID && Array.isArray(authUser.accountAccessList)) {
            const entry = authUser.accountAccessList.find(acc => acc.accountid === accountID)
            if (entry) {
                accessUserID = entry.userid
            }
        }
        const docID = authUser.id || localStorage.userId || ''
        return { accessUserID, docID }
    }
    isCurrentUser = (user) => {
        if (!user) { return false }
        const { accessUserID, docID } = this.getCurrentUserIdentity()
        if (accessUserID && user.accessUserID && user.accessUserID === accessUserID) { return true }
        if (docID && user.userID && user.userID === docID) { return true }
        return false
    }
    // Appel commun à /userRole/suspendUser et /userRole/reactivateUser.
    // Le BFF propage le code HTTP de domainModel : req.ok distingue le succès (200)
    // des protections métier (400) et des cibles introuvables (404).
    // Refus 400 possibles, tous affichés tels quels au porteur de la clé via res.content :
    // cannot_suspend_self, cannot_suspend_account_creator, cannot_suspend_admin_role,
    // not_active, not_suspended.
    // Le 409 concurrent_modification est à part : l'écriture sous CAS a été perdue au profit
    // d'une autre, rien n'est cassé et réessayer est le seul cas où cela a un sens.
    // expectedStatus est le statut que la ligne DOIT porter après l'action (« suspended »
    // ou « active ») : il sert à confirmer que la liste a vraiment été rafraîchie.
    sendAccessAction = async (url, user, successMessage, expectedStatus) => {
        if (!user || !user.userID) {
            toast.error("Utilisateur introuvable")
            return
        }
        this.setState({ accessPending: true })
        try {
            let req = await fetch(url, {
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ userID: user.userID }),
                credentials: 'same-origin',
            })
            const res = await req.json()
            console.log("[INFO] access action", { url, status: req.status, res });

            if (req.status === 409 && res && res.content === 'concurrent_modification') {
                // Écriture concurrente : le document a bougé entre la lecture et l'écriture
                // sous CAS côté domainModel. Aucune donnée n'est incohérente, l'action n'a
                // simplement pas été appliquée. On recharge pour montrer l'état réel et on
                // invite à rejouer, sans afficher d'erreur : ce n'est pas une panne.
                toast.warn("Modification concurrente détectée, réessayez")
                await this.props.fetchUsers(this.apiBase())
                this.filterList()
            } else if (req.status === 409) {
                // account_admin_missing / account_admin_ambiguous / account_binding_mismatch :
                // refus permanent, rejouer la requete ne changera rien, on n'invite pas a reessayer.
                toast.error((res && res.content) ? res.content : "Compte non exploitable")
            } else if (req.ok && res && !res.errorCode) {
                // La suspension reste effective même si l'historique n'a pas pu être écrit
                // côté domainModel : on le signale sans transformer l'action en échec.
                if (res.changed === true && res.historyRecorded === false) {
                    toast.warn("Action appliquée, mais l'historique n'a pas pu être enregistré")
                }
                // fetchUsers réindexe la liste par email : il faut rejouer filterList
                // pour que le tableau reparte du nouveau jeu de clés.
                await this.props.fetchUsers(this.apiBase())
                this.filterList()
                // fetchUsers (paygAction.jsx) avale ses erreurs réseau et ne dispatche que
                // si la réponse porte un roleList : un échec y est silencieux. On ne confirme
                // donc le succès que si la ligne rechargée porte bien le nouveau statut,
                // sinon l'utilisateur croirait la table à jour alors qu'elle est périmée.
                const refreshed = (this.props.USERS || {})[user.email]
                if (refreshed && refreshed.status === expectedStatus) {
                    toast.success(successMessage)
                } else {
                    toast.warn("Action enregistrée, mais la liste n'a pas pu être rafraîchie : rechargez la page")
                }
            } else {
                toast.error((res && res.content) ? res.content : "Un problème est survenu")
            }
        } catch (error) {
            console.log("[ERROR] access action", error);
            toast.error("Erreur lors de la mise à jour de l'accès")
        }
        // AC-26 : les DEUX dialogues sont refermés, en succès comme en échec.
        this.setState({ accessPending: false, confirmSuspend: null, confirmSuspendChoice: null })
    }
    handleSuspend = async (user) => {
        await this.sendAccessAction(this.apiBase() + '/suspendUser', user, "Accès suspendu", 'suspended')
    }
    // Suspension « tous ses comptes » : route scopée UTILISATEUR, hors de apiBase (qui
    // porte un compte). Réservée au chemin SuperAdmin, qui seul passe suspendAllBase :
    // sans cette prop l'action n'existe pas et le comportement de la page admin de compte
    // est strictement inchangé (AC-18).
    // Deux points vérifiés, à connaître plutôt qu'à « corriger » :
    //  - sendAccessAction envoie systématiquement { userID } dans le corps ; la route
    //    globale l'ignore, sa cible venant du chemin. Sans effet, et ne justifie pas de
    //    dupliquer la fonction.
    //  - expectedStatus reste 'suspended' : après une suspension globale, la ligne du
    //    compte affiché passe bien à suspended, donc la confirmation de rafraîchissement
    //    de sendAccessAction reste valide.
    handleSuspendAll = async (user) => {
        if (!this.props.suspendAllBase) { return }
        await this.sendAccessAction(
            this.props.suspendAllBase + '/' + user.userID + '/suspendAll',
            user,
            "Accès suspendu sur tous ses comptes",
            'suspended',
        )
    }
    handleReactivate = async (user) => {
        await this.sendAccessAction(this.apiBase() + '/reactivateUser', user, "Accès rétabli", 'active')
    }
    openAccessHistory = async (user) => {
        this.setState({ historyUser: user, historyList: [], historyLoading: true, historyError: "" })
        try {
            let req = await fetch(this.apiBase() + '/userHistory?userID=' + encodeURIComponent(user.userID || ""), {
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            })
            const res = await req.json()
            console.log("[INFO] access history", { status: req.status, res });

            if (req.ok && res && !res.errorCode) {
                this.setState({
                    historyList: Array.isArray(res.history) ? res.history : [],
                    historyLoading: false,
                })
            } else {
                this.setState({
                    historyLoading: false,
                    historyError: (res && res.content) ? res.content : "Historique indisponible",
                })
            }
        } catch (error) {
            console.log("[ERROR] access history", error);
            this.setState({ historyLoading: false, historyError: "Erreur lors du chargement de l'historique" })
        }
    }
    closeAccessHistory = () => {
        this.setState({ historyUser: null, historyList: [], historyLoading: false, historyError: "" })
    }

    clearForms = () => {
        this.setState({
            roleU:"",// ROLE UPDATE
            roleUDisplay:{value:"", label:""},
            user: {},
            role:"",
            roleDisplay:{value:"", label:""},
            email:"",
            userName:"",
            userPassword:"",
            pages:[],
            roleName:"",
            confirmMDP:"",

            errors:initErrors,
            
            newUser:false,
            newRole:false,
            changeRole:false,
            updatePageList:false,
        })
    }

    createPageList = () => {
        const list = []
            
        PAGES.map( page => { 
            let selected = false
            if( some(this.state.pages, { value: page.value })  )  {  // already selected   
                selected = true 
            } 
            list.push (       
                {value:page.value, label:page.label, disabled:selected} 
            )
        })
        return list
        
    }
    render(){
        const {roleList, list} = this.state
        const { USERS } = this.props;
        let pageSelect = this.createPageList()
        // Compte exploitable pour les actions d'accès mais refusé en 409 sur les
        // mutations (motif admin_mismatch) : la création et la modification
        // d'utilisateur ou de rôle sont désactivées, suspendre, réactiver et
        // historique restent actifs (AC-17). Gardé par suspendAllBase : sans cette
        // prop, donc sur tout le chemin admin de compte, le drapeau est false et le
        // comportement est strictement inchangé (AC-18).
        const mutationsBlocked = !!this.props.suspendAllBase && this.props.mutationsAllowed === false
        let actions = [
            {
                openAction:() => this.setState({ newRole: true, pages: [] }), // évite de reprendre les pages d'une précédente édition de role
                icon:<AddCircleOutline color="primary"/>,
                title: "Nouveau Role"
            },
            {
                openAction: () =>this.setState({ updatePageList: true }),
                icon: <EditRounded color="secondary" />,
                title: "Modifier un role"
            },
            {
                openAction: () =>this.setState({ newUser: true }),
                icon: <PersonRounded style={{ color: blue[200] }} />,
                title: "Nouvel Utilisateur"
            },
           
        ]
                // <Grid container className="text-center">
                //     <Grid item sm={4} xs={12}>
                //         <Button variant="contained" className="btn btn-info" onClick={()=>this.setState({newRole: true})} >Nouveau Role</Button>
                //     </Grid>
                //     <Grid item sm={4} xs={12}>
                //         <Button variant="contained" className="btn bgm-bluegray" onClick={()=>this.setState({updatePageList: true})} >Modifier un role</Button>
                //     </Grid>
                //     <Grid item sm={4} xs={12}>
                //         <Button variant="contained" className="btn btn-info" onClick={()=>this.setState({newUser: true})} >Nouvel Utilisateur</Button>
                //     </Grid>
                // </Grid> 
        
        return (
            <PageAdmin title="Utilisateurs et Roles">
                
                  
                <SearchBarAction
                    list={ USERS }
                    filterList={this.filterList}
                    action={ () => this.setState({openFormTypes: true}) }
                    actionDisabled={mutationsBlocked}
                    actionTitle={mutationsBlocked ? MUTATIONS_BLOCKED_TITLE : undefined}
                />
                {this.state.openFormTypes &&
                    <Dialog
                        title="Nouveau"
                        block={true}
                        close={() => this.setState({ 
                            openFormTypes: false,
                        }) }
                    >
                        {actions.map(action =>
                            <CardButton
                                action={action.openAction}
                                icon={action.icon}
                                title={action.title}
                            />
                        )}
                    </Dialog>
                }
                {this.state.newUser &&
                    <FormNewUser 
                        {...this.state}
                        {...this.props}
                        roleList={roleList}
                        handleChange={this.handleChange}
                        handleSubmit={this.handleSubmit}
                        handleSelect={this.handleSelect}
                        handleClose={this.clearForms}
                    />       
                
                }
                {this.state.newRole &&
                    <FormNewRole
                        {...this.state}
                        {...this.props}
                        pageSelect={pageSelect}
                        handleChange={this.handleChange}
                        handleSubmit={this.handleSubmit}
                        handleSelectPage={this.handleSelectPage}
                        handleClose={this.clearForms}
                    />       
                
                }
                {this.state.updatePageList &&
                    <FormUpdateRole
                        {...this.state}
                        {...this.props}
                        roleList={roleList}
                        pageSelect={pageSelect}
                        handleChange={this.handleChange}
                        handleSubmit={this.handleUpdateRole}
                        handleSelect={this.handleSelect}
                        handleSelectPage={this.handleSelectPage}
                        handleClose={this.clearForms}
                    />     
                
                }
                {this.state.changeRole &&
                    <FormChangeUserRole 
                        {...this.state}
                        {...this.props}
                        roleList={roleList}
                        handleChange={this.handleChange}
                        handleSubmit={this.handleChangeUserRole}
                        handleSelect={this.handleSelect}
                        handleClose={this.clearForms}
                    />     
                
                }
                    
                {this.state.confirmSuspend &&
                    <Dialog
                        title="Suspendre l'accès"
                        block={true}
                        close={() => this.setState({ confirmSuspend: null })}
                        submitAction={() => this.handleSuspend(this.state.confirmSuspend)}
                        submitTitle="Suspendre"
                        disabledSubmit={this.state.accessPending}
                    >
                        <p>
                            Suspendre l'accès de <strong>{this.state.confirmSuspend.name || this.state.confirmSuspend.email}</strong> ({this.state.confirmSuspend.email}) à ce compte ?
                        </p>
                        <p>
                            Son rôle est conservé et l'accès peut être rétabli à tout moment.
                        </p>
                    </Dialog>
                }
                {this.props.suspendAllBase && this.state.confirmSuspendChoice &&
                    // Dialogue à deux boutons via la prop `submit` du composant partagé, qui rend
                    // le nœud fourni dans un DialogActions à côté d'« Annuler ». `submitAction`
                    // n'est PAS passé : les deux blocs sont conditionnés séparément dans
                    // Dialog.jsx et seraient rendus tous les deux.
                    <Dialog
                        title="Suspendre l'accès"
                        block={true}
                        close={() => this.setState({ confirmSuspendChoice: null })}
                        submit={
                            <>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    disabled={this.state.accessPending}
                                    onClick={() => this.handleSuspend(this.state.confirmSuspendChoice)}
                                >
                                    Ce compte seulement
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    disabled={this.state.accessPending}
                                    onClick={() => this.handleSuspendAll(this.state.confirmSuspendChoice)}
                                >
                                    {`Tous ses comptes (${this.state.confirmSuspendChoice.globalSuspensionCount})`}
                                </Button>
                            </>
                        }
                    >
                        <p>
                            Suspendre l'accès de <strong>{this.state.confirmSuspendChoice.name || this.state.confirmSuspendChoice.email}</strong> ({this.state.confirmSuspendChoice.email}) ?
                        </p>
                        <p>
                            <strong>Ce compte seulement</strong> : seul l'accès au compte affiché est suspendu.
                        </p>
                        <p>
                            <strong>Tous ses comptes ({this.state.confirmSuspendChoice.globalSuspensionCount})</strong> : l'accès est suspendu sur l'ensemble de ses comptes en une seule action. Ses rôles sont conservés et chaque accès peut être rétabli compte par compte.
                        </p>
                    </Dialog>
                }
                {this.state.historyUser &&
                    <Dialog
                        title="Historique des accès"
                        block={true}
                        maxWidth="md"
                        close={this.closeAccessHistory}
                    >
                        <p>
                            <strong>{this.state.historyUser.name || this.state.historyUser.email}</strong> ({this.state.historyUser.email})
                        </p>
                        {this.state.historyLoading &&
                            <p>Chargement de l'historique...</p>
                        }
                        {!this.state.historyLoading && this.state.historyError !== "" &&
                            <p className="text-danger">{this.state.historyError}</p>
                        }
                        {!this.state.historyLoading && this.state.historyError === "" && this.state.historyList.length === 0 &&
                            <p>Aucune action enregistrée pour cet utilisateur sur ce compte.</p>
                        }
                        {!this.state.historyLoading && this.state.historyError === "" && this.state.historyList.length > 0 &&
                            <TableLayout>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Action</TableCell>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Auteur</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.historyList.map((entry, index) =>
                                        <TableRow key={index}>
                                            <TableCell>{accessEntryLabel(entry)}</TableCell>
                                            <TableCell>{formatAccessDate(entry.date)}</TableCell>
                                            <TableCell>{entry.adminEmail || entry.adminID}</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </TableLayout>
                        }
                    </Dialog>
                }

                <h3>Liste des Utilisateurs</h3>
                <TableLayout height={"690px"}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Email</TableCell>
                            <TableCell>Role</TableCell>
                            <TableCell>Options</TableCell>
                            <TableCell>Statut</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {USERS && list.map( ID => {
                            let user = USERS[ID]
                            // status vient de /userRole/userList (domainModel) : "active" | "suspended".
                            // Toute autre valeur, y compris absente, est traitée comme active :
                            // on ne grise jamais une ligne par omission.
                            const suspended = user.status === 'suspended'
                            // L'onglet SuperAdmin (apiBase !== '/userRole') est seul durci par
                            // AC-14 : le chemin admin de compte (apiBase par défaut) n'a jamais
                            // masqué ni désactivé le changement de rôle, et le serveur admin ne
                            // connaît pas isSuperAdmin. Ne pas conditionner ici régresse la page
                            // admin (team-fix #9, point 1).
                            const superAdminPath = !!this.props.apiBase && this.props.apiBase !== '/userRole'
                            // Pas d'action de retrait de droits (changement de rôle, suspension) sur
                            // sa propre ligne, sur le créateur du compte, ni (chemin SuperAdmin
                            // uniquement) sur un utilisateur SuperAdmin (rôle 2 ou 5) — AC-14. La
                            // réactivation en est exemptée (§3.3) : elle ne retire rien.
                            const noAction = this.isCurrentUser(user) || user.isAccountAdmin === true || (superAdminPath && user.isSuperAdmin === true)
                            // Motif du blocage, pour le tooltip SuperAdmin uniquement (point 3).
                            // isSuperAdmin n'est testé que sur le chemin SuperAdmin, comme noAction.
                            const blockReason = (superAdminPath && user.isSuperAdmin === true) ? "Super administrateur"
                                : user.isAccountAdmin === true ? "Créateur du compte"
                                : this.isCurrentUser(user) ? "Vous-même"
                                : ""
                            // Le changement de rôle est une mutation : il est aussi désactivé sur
                            // un compte dont le serveur refuse les mutations (AC-17). Le motif de
                            // ligne reste prioritaire quand il existe, il est plus précis.
                            // mutationsBlocked est déjà gardé par suspendAllBase, donc faux sur
                            // le chemin admin de compte (AC-18).
                            const disableChangeRole = (superAdminPath && noAction) || mutationsBlocked
                            const changeRoleBlockReason = (superAdminPath && noAction) ? blockReason : MUTATIONS_BLOCKED_TITLE
                            return(
                                <TableRow key={user.email} style={{ opacity: suspended ? 0.5 : 1 }}>

                                    <TableCell>
                                        {user.email}
                                        {suspended &&
                                            <Chip label="Suspendu" size="small" style={{ marginLeft: 8 }} />
                                        }
                                    </TableCell>
                                    <TableCell>{user.role_name}</TableCell>
                                    <TableCell>
                                        {disableChangeRole ?
                                            // title sur un bouton disabled n'est pas rendu par le
                                            // navigateur : Tooltip MUI posé sur un span conteneur.
                                            <Tooltip title={changeRoleBlockReason}>
                                                <span>
                                                    <IconButton
                                                        className="btn btn-warning btn-icon"
                                                        disabled
                                                        >
                                                        <EditRounded />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        :
                                            <IconButton
                                                className="btn btn-warning btn-icon"
                                                onClick={
                                                    () => this.setState({changeRole: true, user})
                                                }
                                                >
                                                {/* <i className="zmdi zmdi-edit"></i> */}
                                                <EditRounded />
                                            </IconButton>
                                        }
                                        <IconButton
                                            className="btn btn-info btn-icon"
                                            title="Historique des accès"
                                            onClick={
                                                () => this.openAccessHistory(user)
                                            }
                                            >
                                            <HistoryRounded />
                                        </IconButton>
                                    </TableCell>
                                    <TableCell>
                                        {suspended ?
                                            // Chemin SuperAdmin : la réactivation ne retire aucun droit,
                                            // jamais masquée par noAction (AC-14, §3.3). Chemin admin :
                                            // comportement d'avant strictement identique, masqué par
                                            // noAction comme le bouton suspendre (team-fix #13, point 2).
                                            (noAction && !superAdminPath) ? null :
                                            <IconButton
                                                className="btn btn-success btn-icon"
                                                title="Rétablir l'accès"
                                                disabled={this.state.accessPending}
                                                onClick={
                                                    () => this.handleReactivate(user)
                                                }
                                                >
                                                <LockOpenRounded />
                                            </IconButton>
                                        : noAction ? null :
                                                <IconButton
                                                    className="btn btn-danger btn-icon"
                                                    title="Suspendre l'accès"
                                                    disabled={this.state.accessPending}
                                                    onClick={
                                                        // Dialogue de CHOIX seulement sur le chemin
                                                        // SuperAdmin (suspendAllBase) et seulement si
                                                        // le serveur dit que la ligne est le compte
                                                        // natif, que l'action globale aboutirait ET
                                                        // qu'elle porterait sur au moins deux comptes :
                                                        // sous ce seuil, le choix n'a pas d'objet et le
                                                        // dialogue simple suffit (AC-8, AC-10). Le
                                                        // compteur vient du serveur. Aucun calcul
                                                        // local (AC-11, PM-3). Sans la prop, l'expression
                                                        // retombe exactement sur le comportement
                                                        // actuel (AC-18).
                                                        () => (this.props.suspendAllBase && user.isNativeAccount === true && user.globalSuspensionAvailable === true && user.globalSuspensionCount >= 2)
                                                            ? this.setState({ confirmSuspendChoice: user })
                                                            : this.setState({ confirmSuspend: user })
                                                    }
                                                    >
                                                    <BlockRounded />
                                                </IconButton>
                                        }
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </TableLayout>
            </PageAdmin>
        )
    }
}

export default UsersList;




